<div class="row">
    <div style="position: fixed;    z-index: 5;">
        <app-filter [collapseFromParent]="collapseFromParent" (collapseCloseToparent)="getCollapseValue($event)" (onSubmitFilter)="getDataValuee($event)" (onPushFilters)="EmitFilterOpportunite($event)" [onRefreshFilter]="filtre" [filterSsearch]="filterSsearch" ></app-filter>
    </div>
</div>

<div class="row" #myDiv>
    <!-- Datatables -->
    <div class="col-lg-12 p-0">
        <div class="navbar-center row">
            <div class="col">
                <div class="row position-absolute flex-nowrap" style="right: 0px">
                    <div class="col text-nowrap text-right mt-2">
                        <p>{{ 'languages.listing.label_goto' | translate}}</p>
                    </div>
                    <div class="col mt-1 ml-2">
                        <input [(ngModel)]="intervale" size="1" min="1" onkeypress="return event.charCode >= 48" (keyup.enter)="getchangeLimite()" (change)="getchangeLimite()" type="number" style="margin-left: 4px;" size="1" class="page_input bg-white border rounded font-weight-bold"
                            [value]="pages" max="{{totalPages}}">
                    </div>
                </div>
            </div>

        </div>

        <div class="card mb-4 border-0" style="border-radius: 13px; ">
            <div class="row d-flex justify-content-center align-items-center">
                <div class="col-3 ">
                    <button type="button" class="btn-dt-add  ml-4" (click)="toAdd()" [attr.data-title]="'languages.opportunite.addOpp' | translate">
                        <i class="fa-solid fa-plus"></i>
          </button>
                </div>
                <div class="col-6 blocDate mt-2">
                    <div class="row d-flex justify-content-center align-items-center">
                        <!-- <div class="col-5">
                            <mat-form-field appearance="fill" class="w-100">
                                <mat-label>{{ 'languages.listing.label_debutdate' | translate}}</mat-label>
                                <input matInput [matDatepicker]="pickerDebut" id="date_debut" name="date_debut" [(ngModel)]="date_debut" [value]="date_debut">
                                <mat-datepicker-toggle matSuffix [for]="pickerDebut"></mat-datepicker-toggle>
                                <mat-datepicker #pickerDebut></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-5">
                            <mat-form-field appearance="fill" class="w-100">
                                <mat-label>{{ 'languages.listing.label_enddate' | translate}}</mat-label>
                                <input matInput [matDatepicker]="pickerFin" id="date_fin" name="date_fin" [(ngModel)]="date_fin" [value]="date_fin | date:'yyyy-MM-dd'">
                                <mat-datepicker-toggle matSuffix [for]="pickerFin"></mat-datepicker-toggle>
                                <mat-datepicker #pickerFin></mat-datepicker>
                            </mat-form-field>
                        </div> -->
                        <div class="col-2">
                            <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M28.4162 5.93325V3.33325C28.4162 2.64992 27.8495 2.08325 27.1662 2.08325C26.4828 2.08325 25.9162 2.64992 25.9162 3.33325V5.83325H15.0828V3.33325C15.0828 2.64992 14.5162 2.08325 13.8328 2.08325C13.1495 2.08325 12.5828 2.64992 12.5828 3.33325V5.93325C8.08282 6.34992 5.89949 9.03325 5.56615 13.0166C5.53282 13.4999 5.93282 13.8999 6.39949 13.8999H34.5995C35.0828 13.8999 35.4828 13.4833 35.4328 13.0166C35.0995 9.03325 32.9162 6.34992 28.4162 5.93325Z" fill="#0F1D64"/>
                                <path opacity="0.4" d="M35.4995 18.0632V20.9632C35.4995 21.9799 34.5995 22.7632 33.5995 22.5965C33.1328 22.5299 32.6495 22.4799 32.1662 22.4799C29.7364 22.4843 27.4074 23.4515 25.6892 25.1696C23.9711 26.8877 23.0039 29.2168 22.9995 31.6466C22.9995 32.4132 23.2995 33.4799 23.6162 34.4465C23.7018 34.6976 23.7261 34.9655 23.687 35.2279C23.648 35.4903 23.5468 35.7396 23.3919 35.9549C23.2369 36.1702 23.0327 36.3453 22.7963 36.4656C22.5599 36.5859 22.2981 36.648 22.0328 36.6466H13.8328C7.99951 36.6466 5.49951 33.3132 5.49951 28.3132V18.0465C5.49951 17.1299 6.24951 16.3799 7.16618 16.3799H33.8328C34.7495 16.3965 35.4995 17.1465 35.4995 18.0632Z" fill="#0F1D64"/>
                                <path d="M32.1662 25.0001C28.4828 25.0001 25.4995 27.9834 25.4995 31.6667C25.4995 32.9167 25.8495 34.1001 26.4662 35.1001C27.0537 36.0876 27.8883 36.905 28.8878 37.472C29.8872 38.0389 31.0171 38.3358 32.1662 38.3334C34.5995 38.3334 36.7162 37.0334 37.8662 35.1001C38.4828 34.1001 38.8328 32.9167 38.8328 31.6667C38.8328 27.9834 35.8495 25.0001 32.1662 25.0001ZM35.6162 30.9501L32.0662 34.2334C31.8328 34.4501 31.5162 34.5667 31.2162 34.5667C30.8995 34.5667 30.5828 34.4501 30.3328 34.2001L28.6828 32.5501C28.4504 32.3149 28.32 31.9975 28.32 31.6667C28.32 31.336 28.4504 31.0186 28.6828 30.7834C29.1662 30.3001 29.9662 30.3001 30.4495 30.7834L31.2495 31.5834L33.9162 29.1167C34.4162 28.6501 35.2162 28.6834 35.6828 29.1834C36.1495 29.6834 36.1162 30.4667 35.6162 30.9501ZM14.6662 25.0001C14.2328 25.0001 13.7995 24.8168 13.4828 24.5168C13.1828 24.2001 12.9995 23.7668 12.9995 23.3334C12.9995 22.9001 13.1828 22.4668 13.4828 22.1501C13.8662 21.7668 14.4495 21.5834 14.9995 21.7001C15.0995 21.7168 15.1995 21.7501 15.2995 21.8001C15.3995 21.8334 15.4995 21.8834 15.5995 21.9501L15.8495 22.1501C16.1495 22.4668 16.3328 22.9001 16.3328 23.3334C16.3328 23.7668 16.1495 24.2001 15.8495 24.5168L15.5995 24.7168C15.4995 24.7834 15.3995 24.8334 15.2995 24.8668C15.1995 24.9168 15.0995 24.9501 14.9995 24.9667C14.8828 24.9834 14.7662 25.0001 14.6662 25.0001ZM20.4995 25.0001C20.0662 25.0001 19.6328 24.8168 19.3162 24.5168C19.0162 24.2001 18.8328 23.7668 18.8328 23.3334C18.8328 22.9001 19.0162 22.4668 19.3162 22.1501C19.9495 21.5334 21.0662 21.5334 21.6828 22.1501C21.9828 22.4668 22.1662 22.9001 22.1662 23.3334C22.1662 23.7668 21.9828 24.2001 21.6828 24.5168C21.3662 24.8168 20.9328 25.0001 20.4995 25.0001ZM14.6662 30.8318C14.2328 30.8318 13.7995 30.6484 13.4828 30.3484C13.1828 30.0317 12.9995 29.5984 12.9995 29.1651C12.9995 28.7318 13.1828 28.2984 13.4828 27.9817C13.6495 27.8317 13.8162 27.7151 14.0328 27.6318C14.6495 27.3651 15.3828 27.5151 15.8495 27.9817C16.1495 28.2984 16.3328 28.7318 16.3328 29.1651C16.3328 29.5984 16.1495 30.0317 15.8495 30.3484C15.5328 30.6484 15.0995 30.8318 14.6662 30.8318Z" fill="#0F1D64"/>
                                </svg>                    </div>
                        <div class="col-8">

                              <mat-form-field appearance="fill" class="w-100">
                                <mat-date-range-input [rangePicker]="picker"  >
                                  <input matStartDate [(ngModel)]="date_debut" readonly placeholder=" {{'languages.convention.DateDeb' | translate}}"  (click)="openDatePicker()" />
                                  <input matEndDate [(ngModel)]="date_fin" readonly placeholder="{{'languages.convention.DateFin' | translate}} " (click)="openDatePicker()"/>

                                </mat-date-range-input>

                                <mat-datepicker-toggle class="m-0 p-0" matPrefix [for]="picker">    <mat-icon matDatepickerToggleIcon>
                                    <img src="assets/icons/calendar.svg" alt="calendarIcon" >
                                </mat-icon></mat-datepicker-toggle>
                                <img  class="remouveDate" matSuffix (click)="clearDateCreation()"  alt="deleteIcon" src="assets/icons/delete-left.svg">
                                <mat-date-range-picker  [calendarHeaderComponent]="rangeDateCreation" #picker></mat-date-range-picker>
                              </mat-form-field>

                          </div>
                        <div class="col-2 w-100 pl-0 ">
                            <button type="button" class="filtrer" (click)="getDataValuee('filtrer')">
                                <img src="assets/icons/filtre.svg" class="mr-3" alt="">
                {{'languages.buttons.filtrer' | translate}}
              </button>
                        </div>
                    </div>
                </div>
                <div class="col-3 p-2  text-right">
                    <input class="search" name="" [(ngModel)]="filtres_opportuniteInit.sSearch"   (input)="onInputChange($event.target.value)" placeholder="{{'languages.buttons.rechercher' | translate}}...">
                    <i aria-hidden="true" class="fa-solid fa-magnifying-glass icon-search fa-md"></i>
                </div>
                <!-- <div class="col-3  p-2 d-flex justify-content-center">
                    <button class="filtreFavoris">
                        <img class="mr-3" src="assets/icons/filtreFavoris.svg">
                        {{'languages.buttons.rechercheFavories' | translate}}
                    </button>
                </div> -->


            </div>
            <div class="row mt-3 " >
                <!--  <button  type="button" (click)="updateOpportunities()" class="btn-keygen ml-4" id="keygen" style="background-color:#fe8c96; width: 150px;">
            Actions groupées
          </button> -->

                <button type="button" *ngIf="actionGroupeAccess" class="btn-dt-actions-groupee ml-4" (click)="updateOpportunities()" [disabled]="!actionButton"
                >
                {{ 'languages.groupedactions.groupedactions' | translate}}
        </button>


            <div class="table-responsive p-3">
                <table class="table align-items-center" id="dataTable1">
                    <thead class="head-table">
                        <tr>
                            <th>

                                <input type="checkbox" [(ngModel)]="masterSelected" name="list_name" value="m1" (change)="checkUncheckAll()" />
                            </th>
                            <th>
                                {{ 'languages.listing.actions' | translate}}
                            </th>
                            <th (click)="setSortField('opportunite_date_depot')">{{ 'languages.opportunite.label_creation' | translate}}
                                <div class="d-inline-block" [ngClass]="{'sort-up': sort_type === 'asc' , 'sort-down': sort_type === 'desc' ,'sort-active': sort_field=='opportunite_date_depot'}">
                                    <i class="fa-solid fa-arrow-down-short-wide fa-lg ml-2"></i>
                                </div>
                            </th>
                            <th (click)="setSortField('organismes_nom')">
                                {{ 'languages.campagne.Organisme' | translate}}
                                <div class="d-inline-block" [ngClass]="{'sort-up': sort_type === 'asc' , 'sort-down': sort_type === 'desc' ,'sort-active': sort_field=='organismes_nom'}">
                                    <i class="fa-solid fa-arrow-down-short-wide fa-lg ml-2"></i>
                                </div>
                            </th>

                            <th (click)="setSortField('villes_postal_code')">
                                {{ 'languages.opportunite.label_zonecode' | translate}}
                                <div class="d-inline-block" [ngClass]="{'sort-up': sort_type === 'asc' , 'sort-down': sort_type === 'desc' ,'sort-active': sort_field=='villes_postal_code'}">
                                    <i class="fa-solid fa-arrow-down-short-wide fa-lg ml-2"></i>
                                </div>
                            </th>
                            <th (click)="setSortField('prospects_surname')">
                                RS/Prospect
                                <div class="d-inline-block" [ngClass]="{'sort-up': sort_type === 'asc' , 'sort-down': sort_type === 'desc' ,'sort-active': sort_field=='prospects_surname'}">
                                    <i class="fa-solid fa-arrow-down-short-wide fa-lg ml-2"></i>
                                </div>
                            </th>
                            <!--     <th (click)="setSortField('rdv')">
                {{ 'languages.opportunite.label_rdv' | translate}}
                <div class="d-inline-block"
                  [ngClass]="{'sort-up': sort_type === 'asc' , 'sort-down': sort_type === 'desc' ,'sort-active': sort_field=='rdv'}">
                <i class="fa-solid fa-arrow-down-short-wide fa-lg ml-2"></i>
                </div>
              </th> -->
                            <th (click)="setSortField('campagnes_libelle')">
                                {{ 'languages.organisme.Campagne' | translate}}
                                <div class="d-inline-block" [ngClass]="{'sort-up': sort_type === 'asc' , 'sort-down': sort_type === 'desc' ,'sort-active': sort_field=='campagnes_libelle'}">
                                    <i class="fa-solid fa-arrow-down-short-wide fa-lg ml-2"></i>
                                </div>
                            </th>
                            <th (click)="setSortField('etat')">
                                {{ 'languages.opportunite.label_status' | translate}}
                                <div class="d-inline-block" [ngClass]="{'sort-up': sort_type === 'asc' , 'sort-down': sort_type === 'desc' ,'sort-active': sort_field=='etat'}">
                                    <i class="fa-solid fa-arrow-down-short-wide fa-lg ml-2"></i>
                                </div>
                            </th>
                            <th style="width: 220px;"> {{ 'languages.groupedactions.mots_cles' | translate}}</th>
                        </tr>
                    </thead>
                    <tbody class="body-table" *ngFor="let opportunity of opportunityList.aaData; let i = index">
                        <tr>
                            <td>
                                <div class="pt-1">
                                    <label class="container">
                    <input type="checkbox" [(ngModel)]="opportunity.isSelected" name="list_name"
                      value="{{opportunity.id}}" (change)="isAllSelected()">
                  </label>


                                </div>
                            </td>
                            <td>
                                <div class="d-flex justify-content-center align-items-center">

                                    <div class="pt-1 mr-2">
                                        <button type="button" class="btn-dt-list" data-toggle="modal" data-target="#ActionsPhone" (click)="getPhoneList(opportunity.opportunite_id)">
                      <img src="/assets/icons/phone-icon.svg">
                    </button>
                                    </div>
                                    <div class="pt-1 mr-2">
                                        <a type="button" class="btn-dt-list" (click)="goToEdit()" routerLink="/opportunities/details/{{opportunity.opportunite_id}}/">
                                            <img src="/assets/icons/edit-icon.svg">
                                        </a>
                                    </div>
                                    <div>
                                        <input type='checkbox' id="permanent_{{i}}" title="Add Favoris" class="star" [checked]="opportunity.add_to_fav" />
                                        <label for="permanent_{{i}}" (click)="add_suivi_opp(opportunity.opportunite_id)"></label>
                                    </div>
                                </div>



                            </td>
                            <td>{{opportunity.date_depot | date:'dd-MM-yyyy HH:mm'}}</td>
                            <td width="150px;">{{opportunity.organismes_nom}}</td>
                            <td width="150px;">{{ opportunity.adresse || '-' }}</td>                            
                            <td>{{ opportunity.RS ? opportunity.RS : opportunity.prospects_name + " " +opportunity.prospects_surname}}</td>
                            <!-- <td>{{opportunity.opportunite_type_libelle}}</td> -->
                            <td width="150px;">{{opportunity.campagnes_libelle}}</td>
                            <td>
                                <div class="btn-status d-flex justify-content-center" [style.background]="opportunity.etat_background" [style.color]="opportunity.etat_color">{{opportunity.etat}}</div>
                            </td>


                            <td style="width: 290px; " *ngIf="opportunity.tags_list.length > 0">
                                <div class="tagsOpportunite pb-1" id="tagsList">
                                    <mat-chip-set class="example-chip">
                                        <mat-chip class="example-box mr-2 mt-2" [ngStyle]="{'background-color':tag.couleur_background, 'color':tag.couleur}" *ngFor="let tag of opportunity.tags_list; let index = index ; let first = first;">
                                            {{tag.libelle}}
                                        </mat-chip>
                                    </mat-chip-set>
                                </div>
                            </td>
                            <td *ngIf="opportunity.tags_list.length == 0">-</td>
                        </tr>
                    </tbody>
                </table>
                <div class="row d-flex justify-center align-items-center text-center ">
                    <p *ngIf="opportunityList.aaData?.length===0"  class="col-12 noOpp"> Pas des opportunités  </p>
                   </div>
            </div>
        </div>
        <div class="navbar-center mb-4 row">
            <div class="col pt-1">
                <div class="row w-50 flex-nowrap">
                    <div class="col mt-1">
                        <p>{{ 'languages.miniListing.Afficher' | translate}}</p>
                    </div>
                    <div class="col mx-1">
                        <select [(ngModel)]="limit" (change)="updateListOpportunities()" class="bg-white border pt-1 rounded font-weight-bold">
              <option value="15">15</option>
              <option value="25">25</option>
              <option value="30">30</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
                    </div>
                    <div class="col mt-1">
                        <p class="text-nowrap">{{ 'languages.miniListing.pagesPerPage' | translate}} {{totalLength}} {{ 'languages.miniListing.element' | translate}}</p>
                    </div>
                </div>
            </div>
            <div class="col-8">
                <nav aria-label="Page navigation example" *ngIf="totalPages>0">
                    <ul class="pagination pg-blue">
                        <li (click)="first()" class="page-item" [ngClass]="{'disabled':isFirst()}">
                            <a class="page-link-symbol">
                                <span aria-hidden="true">&laquo;</span>
                            </a>
                        </li>
                        <li *ngIf="!isFirst()" (click)="prev()" class="page-item mx-2">
                            <a class="page-link-symbol-chevron" aria-label="Previous">
                                <i class="fa fa-chevron-left "></i>
                            </a>
                        </li>
                        <ng-container *ngFor="let item of [].constructor(3); let i = index">
                            <li *ngIf="i+pages-3>0" class="page-item">
                                <a (click)="changepage(i+pages-3)" class="page-link mt-2 border rounded">{{i + pages - 3}}</a>
                            </li>
                        </ng-container>
                        <ng-container *ngFor="let item of [].constructor(3); let i = index">
                            <li *ngIf="i+pages<totalPages" class="page-item">
                                <a (click)="changepage(i+pages)" class="page-link mt-2 border rounded" [ngClass]="{'active-page':pages==(i+pages)}">
                  {{i + pages}}
                </a>
                            </li>
                        </ng-container>
                        <li *ngIf="totalPages>1 && totalPages > 3 " class="m-2"> ... </li>
                        <li class="page-item">
                            <a (click)="changepage(totalPages)" class="page-link mt-2 border rounded" [ngClass]="{'active-page':pages==totalPages}">{{totalPages}}</a>
                        </li>
                        <li *ngIf="!isLast()" (click)="next()" class="page-item mx-2">
                            <a class="page-link-symbol-chevron" aria-label="Next">
                                <i class="fa fa-chevron-right"></i>
                            </a>
                        </li>
                        <li (click)="last()" class="page-item" [ngClass]="{'disabled':isLast()}">
                            <a class="page-link-symbol">
                                <span aria-hidden="true">&raquo;</span>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
            <div class="col">
                <div class="row position-absolute flex-nowrap" style="right: 0px">
                    <div class="col text-nowrap text-right mt-2">
                        <p>{{ 'languages.listing.label_goto' | translate}}</p>
                    </div>
                    <div class="col mt-1 ml-2">
                        <input [(ngModel)]="intervale" size="1" min="1" onkeypress="return event.charCode >= 48" (keyup.enter)="getchangeLimite()" (change)="getchangeLimite()" type="number" style="margin-left: 4px;" size="1" class="page_input bg-white border rounded font-weight-bold"
                            [value]="pages" max="{{totalPages}}">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Datatables -->
</div>
<!-------------------------------------------Action Groupés------------------------------------------->
<div class="modal fade" id="ActionsGroupes" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog model-lg" role="document">
        <div class="modal-content" style="width: 60rem; margin-left: -135px;">
            <div class="modal-header">
<i class="fa-solid fa-list-check fa-2x"></i>
                <h2 style="margin-left: 15px">{{ 'languages.groupedactions.groupedactions' | translate}}</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class='checkbox-container col-lg-12' style="font-size:2em; margin-bottom: 30px;">
                        <label for="toggle1" style="font-size: 20px;padding-left: 13px;">{{ 'languages.opportunite.label_changenegotiator' |
              translate}}</label>
                        <input class="checkbox" type="checkbox" id="toggle1" name="negociateur" value="negociateur" [(ngModel)]="Negociateur">
                        <div class="checkbox-visual" style="margin-left: 15px;">
                            <div></div>
                        </div>
                    </div>
                    <div class="col-12" *ngIf="Negociateur">
                        <input type="search" name="negociateur" class="form-control" style="position: absolute; left: 30%; width: 30%;">
                    </div>
                    <div class='checkbox-container col-lg-12' style="font-size:2em; margin-bottom: 30px;">
                        <label for="toggle1" style="font-size: 20px;padding-left: 13px;">{{ 'languages.opportunite.label_changestatus' |
              translate}}</label>
                        <input class="checkbox" type="checkbox" id="toggle2" name="statut" value="statut" [(ngModel)]="Statut">
                        <div class="checkbox-visual" style="margin-left: 15px;">
                            <div></div>
                        </div>
                    </div>
                    <div class='checkbox-container col-lg-12' style="font-size:2em; margin-bottom: 30px;">
                        <label for="toggle1" style="font-size: 20px;padding-left: 13px;">{{ 'languages.opportunite.label_addopportunitytags'
              | translate}}</label>

                        <input class="checkbox" type="checkbox" id="toggle3" name="tags-opportunites" value="tags-opportunites" [(ngModel)]="TagsOpportunites">
                        <div class="checkbox-visual" style="margin-left: 15px;">
                            <div></div>
                        </div>
                    </div>
                    <div class="col-12" *ngIf="TagsOpportunites">
                        <select class="form-control" style="margin: auto;margin-bottom: 15px; width: 30%">
              <option selected disabled>{{ 'languages.opportunite.label_add' | translate}}</option>
            </select>
                    </div>
                    <div class='checkbox-container col-lg-12' style="font-size:2em; margin-bottom: 30px;">
                        <label for="toggle1" style="font-size: 20px;padding-left: 13px;">{{ 'languages.opportunite.label_tagprospect' | translate}}</label>
                        <input class="checkbox" type="checkbox" id="toggle4" name="tags-prospects" value="tags-prospects" [(ngModel)]="TagsProspects">
                        <div class="checkbox-visual" style="margin-left: 15px;">
                            <div></div>
                        </div>
                    </div>
                    <div class="col-12" *ngIf="TagsProspects">
                        <select class="form-control" style="margin: auto;margin-bottom: 15px; width: 30%">
              <option selected disabled>{{ 'languages.opportunite.label_add' | translate}}</option>
            </select>
                    </div>
                    <div class='checkbox-container col-lg-12' style="font-size:2em; margin-bottom: 30px;">
                        <label for="toggle1" style="font-size: 20px;padding-left: 13px;">{{ 'languages.opportunite.label_communication' | translate}}</label>
                        <input class="checkbox" type="checkbox" id="toggle5" name="communications" value="communications" [(ngModel)]="Communications">
                        <div class="checkbox-visual" style="margin-left: 15px;">
                            <div></div>
                        </div>
                    </div>
                    <div class="col-12" *ngIf="Statut" style="margin: auto">
                        <div class="box">
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="status" value="RDV Terrain">
                                <label class="form-check-label">{{ 'languages.opportunite.label_fieldmeeting' | translate}}</label> <br>
                                <input class="form-check-input" type="radio" name="status" value="VAD">
                                <label class="form-check-label">{{ 'languages.opportunite.label_vad' | translate}}</label><br>
                                <input class="form-check-input" type="radio" name="status" value="Vente Bureaux">
                                <label class="form-check-label">{{ 'languages.opportunite.label_salesoffices' | translate}}</label><br>
                                <input class="form-check-input" type="radio" name="status" value="TRANSFERT">
                                <label class="form-check-label">{{ 'languages.opportunite.label_transfert' | translate}}</label><br>
                                <input class="form-check-input" type="radio" name="status" value="Qualification">
                                <label class="form-check-label">{{ 'languages.opportunite.label_qualification' | translate}}</label><br>
                                <input class="form-check-input" type="radio" name="status" value="3C">
                                <label class="form-check-label">{{ 'languages.opportunite.label_3c' | translate}}</label><br>
                                <input class="form-check-input" type="radio" name="status" value="ASSUR-COVID-2020">
                                <label class="form-check-label">{{ 'languages.opportunite.label_covidinsurance' | translate}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" *ngIf="Communications">
                        <select class="form-control" style="margin: auto;margin-bottom: 15px; width: 30%">
              <option selected disabled>{{ 'languages.opportunite.label_mail' | translate}}</option>
            </select>
                        <select class="form-control" style="margin: auto;margin-bottom: 15px; width: 30%">
              <option selected disabled>{{ 'languages.opportunite.label_sms' | translate}}</option>
            </select>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="row">
                    <button class="btn-style" type="submit">{{ 'languages.opportunite.label_treat' | translate}}</button>
                    <button class="btn-style" data-dismiss="modal">{{ 'languages.buttons.fermer' | translate}}</button>
                </div>
            </div>
        </div>
    </div>
</div>
<!--------------------------------Action Phone----------------------------------->
<div class="modal fade" id="ActionsPhone" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog model-lg" role="document">
        <div class="modal-content" style="width: 60rem; margin-left: -135px;">
            <div class="modal-header">
<i class="fa-solid fa-phone-flip fa-2x"></i>
                <h2 style="margin-left: 15px">{{ 'languages.opportunite.label_phoneactions' | translate}}</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col">
                        <div class="row" *ngIf="list_tel.mobile!= null && list_tel.mobile!=''">
                            <div class="col-3 text-center">
                                {{ 'languages.prospect.Mobile' | translate}}
                            </div>
                            <div class="col-6 text-center">
                                {{this.list_tel.mobile}}
                            </div>
                            <div class="col-3 text-center">

                                <button class="btn" (click)="callVoip(list_tel.mobile)">
                  <i class="fa-solid fa-phone-flip fa-lg" style="margin-left: 5px; color: #43ac43;"></i>
                </button>
                            </div>
                        </div>
                        <div class="row" *ngIf="list_tel.tel!= null && list_tel.tel!=''">
                            <div class="col-3 text-center">
                                {{ 'languages.prospect.phone' | translate}}
                            </div>
                            <div class="col-6 text-center">
                                {{this.list_tel.tel}}
                            </div>
                            <div class="col-3 text-center">

                                <button class="btn" (click)="callVoip(list_tel.tel)">
                  <i class="fa-solid fa-phone-flip fa-lg" style="margin-left: 5px; color: #43ac43;"></i>
                </button>
                            </div>
                        </div>
                        <div class="row" *ngIf="list_tel.tel2!= null && list_tel.tel2!=''">
                            <div class="col-3 text-center">
                                {{ 'languages.prospect.phone' | translate}} 2
                            </div>
                            <div class="col-6 text-center">
                                {{this.list_tel.tel2}}
                            </div>
                            <div class="col-3 text-center">
                                <button class="btn" (click)="callVoip(list_tel.tel2)">
                  <i class="fa-solid fa-phone-flip fa-lg" style="margin-left: 5px; color: #43ac43;"></i>
                    
                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="row">
                    <button class="btn-style" data-dismiss="modal">{{ 'languages.buttons.fermer' | translate}}</button>
                </div>
            </div>
        </div>
    </div>
</div>
<!--------------------------------Action Vue----------------------------------->
<div class="modal fade" id="ActionsVue" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog model-lg" role="document">
        <div class="modal-content" style="width: 60rem; margin-left: -135px;">
            <div class="modal-header">
<i class="fa-solid fa-eye fa-2x"></i>
                <h2 style="margin-left: 15px">{{ 'languages.opportunite.label_viewactions' | translate}}</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
            </div>
            <div class="modal-body">
                <div class="row">
                </div>
            </div>
            <div class="modal-footer">
                <div class="row">
                    <button class="btn-style" type="submit">{{ 'languages.opportunite.label_treat' | translate}}</button>
                    <button class="btn-style" data-dismiss="modal">{{ 'languages.buttons.fermer' | translate}}</button>
                </div>
            </div>
        </div>
    </div>
</div>
